export const normalize: (min: number, max: number, value: number) => number = (min, max, value) => {
  let normalizedValue = value;

  // We skip the calculation if difference of max and min is equal to or less than 0 since, division with zero result out NaN or Infinity
  if (max - min > 0) {
    normalizedValue = ((value - min) / (max - min)) * 100;
  }

  // we truncate to two decimals to follow used number format
  return parseFloat(normalizedValue.toFixed(2));
};
